import React, { useState, useEffect } from "react";

import moment from "moment";
import Grid from "@material-ui/core/Grid";
import Divider from "@material-ui/core/Divider";
import { makeStyles } from "@material-ui/core/styles";

import Firebase from "../../firebasehelper";

const referralImg = require("../../assets/media/profile/laugh.png");

const useStyles = makeStyles((theme) => ({
  cta: {
    display: "flex",
    flexDirection: "row",
    marginTop: "20px",
    marginBottom: "20px",
    alignItems: "center",
  },
}));

const ViewReferralModal = ({ user, brandData }) => {
  const [loading, setLoading] = useState(false);
  const [referralData, setReferralData] = useState([]);

  const classes = useStyles();

  useEffect(() => {
    Firebase.getReferralsByBrand(brandData.name, (res) => {
      const referrals = res.filter((ref) => ref.memberID === user.id) || [];
      setReferralData(referrals);
      console.log("referrals ---", referrals);
    });
  }, [user]);

  const renderContent = () => {
    return (
      <div className="modal-body pb-1">
        {loading && (
          <div style={{ display: "flex", justifyContent: "center" }}>
            <i class="fa fa-4x fa-sync fa-spin text-muted" />
          </div>
        )}
        {!loading && (
          <div className="table-header">
            <Grid container spacing={3} alignItems="center">
              <Grid item xs={2}>
                <p>Date</p>
              </Grid>
              <Grid item xs={4}>
                <p>Referred prospect name</p>
              </Grid>
              <Grid item xs={2}>
                <p>Routing</p>
              </Grid>
              <Grid item xs={4}>
                <p>Converted to member</p>
              </Grid>
            </Grid>
          </div>
        )}
        {!loading &&
          referralData.map((referral) => {
            return (
              <div className="table-content">
                <Grid container spacing={3} alignItems="center">
                  <Grid item xs={2}>
                    <p>{moment(referral.time).format("DD.MM.YYYY")}</p>
                  </Grid>
                  <Grid item xs={4}>
                    <p>{referral.referredUserName}</p>
                  </Grid>
                  <Grid item xs={2}>
                    <p>{referral.routing}</p>
                  </Grid>
                  <Grid item xs={4}>
                    <p>
                      {referral.user_access === "Referred prospect" ||
                      referral.user_access === "Pending member"
                        ? "Pending"
                        : "Converted"}
                    </p>
                  </Grid>
                </Grid>
              </div>
            );
          })}
        <Divider />
        <div className={classes.cta}>
          <button
            className="btn btn-white"
            style={{ marginLeft: "auto", marginRight: "20px" }}
            data-dismiss="modal"
          >
            OK
          </button>
        </div>
      </div>
    );
  };

  const renderNoReferral = () => {
    return (
      <div className="modal-body pb-1">
        <div className="no-referral-content">
          <img alt="" src={referralImg} />
          <div>
            <p>{`${user.firstname} does not have any referrals yet.`}</p>
            <button className="btn btn-white" data-dismiss="modal">
              OK
            </button>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div
      className="modal fade"
      id="view_referral_modal"
      tabIndex="-1"
      role="dialog"
      aria-labelledby="modal-default-fadein"
      aria-hidden="true"
    >
      <div
        className="modal-dialog"
        role="document"
        style={{
          marginTop: "200px",
          maxWidth: referralData.length > 0 ? "800px" : "400px",
        }}
      >
        <div
          className={`modal-content ${
            referralData.length === 0 && "black-border"
          }`}
          style={{ borderRadius: "40px" }}
        >
          {referralData.length > 0 ? renderContent() : renderNoReferral()}
        </div>
      </div>
    </div>
  );
};

export default ViewReferralModal;



// WEBPACK FOOTER //
// ./src/screens/Users/ViewReferralModal.jsx